import api from "src/services/api";

export interface RelevamientoPreguntaOpcion {
  id?: number;
  pregunta_id?: number | null;
  codigo: string;
  etiqueta: string;
  orden?: number;
}

export interface RelevamientoPregunta {
  id: number;
  codigo: string;
  texto: string;
  tipo_respuesta: string;
  orden?: number;
  requerido?: boolean;
  opciones?: RelevamientoPreguntaOpcion[];
}

export interface RelevamientoContexto {
  ps?: {
    id: number;
    codigo: string;
    nombre: string;
  };
  contacto?: {
    nombre?: string;
    telefono?: string;
  };
  ejecutivo?: {
    nombre?: string;
    correo?: string;
  };
}

export interface RelevamientoRegistro {
  id: number;
  ps_id: number | null;
  ps_codigo: string | null;
  ps_nombre: string;
  ejecutivo?: string;
  encargado?: string;
  puesto_contacto?: string;
  observaciones?: string;
  fecha_visita?: string;
  creado_por_usuario?: string;
  creado_por_cargo?: string;
  fecha_creacion?: string;
  es_prospecto?: boolean | number;
}

export interface RelevamientoPuntoServicio {
  id: number;
  ps_nombre: string;
  ps_codigo: string;
}

export interface RelevamientoOpcionesResponse {
  preguntas: RelevamientoPregunta[];
  preguntas_si_no?: RelevamientoPregunta[];
  calificacion_limpieza?: RelevamientoPregunta | null;
  campo_encargado?: { codigo: string; texto: string };
  campo_observaciones?: { codigo: string; texto: string };
}

export interface RelevamientoListadoFiltros {
  ps_codigo?: string;
  fecha_desde?: string;
  fecha_hasta?: string;
  ejecutivo?: string;
  limit?: number;
  offset?: number;
}

export interface RelevamientoListadoResponse {
  datos: RelevamientoRegistro[];
  total: number;
  limit: number;
  offset: number;
  puede_ver_todas: boolean;
}

export interface RelevamientoRespuestaDetalle {
  id: number;
  pregunta_id: number;
  pregunta_codigo: string;
  pregunta_texto: string;
  pregunta_orden?: number;
  opcion_id: number;
  opcion_codigo: string;
  opcion_etiqueta: string;
}

export interface RelevamientoDetalle extends RelevamientoRegistro {
  respuestas: RelevamientoRespuestaDetalle[];
}

export const listarOpcionesRelevamiento = async (): Promise<RelevamientoOpcionesResponse> => {
  const { data } = await api.get("relevamiento-visitas/opciones");
  if (data?.error) throw new Error(data.error);
  return data?.datos || { preguntas: [] };
};

export const buscarPuntosServicioRelevamiento = async (
  q: string
): Promise<RelevamientoPuntoServicio[]> => {
  const suffix = q ? `?q=${encodeURIComponent(q)}` : "";
  const { data } = await api.get(`relevamiento-visitas/puntos-servicio${suffix}`);
  if (data?.error) throw new Error(data.error);
  return data?.datos || [];
};

export const obtenerContextoRelevamiento = async (
  params: { psId?: number; psCodigo?: string }
): Promise<RelevamientoContexto | null> => {
  const query = params.psId
    ? `ps_id=${params.psId}`
    : `ps_codigo=${encodeURIComponent(String(params.psCodigo || ""))}`;
  const { data } = await api.get(`relevamiento-visitas/contexto?${query}`);
  if (data?.error) throw new Error(data.error);
  return data?.datos || null;
};

export const crearRelevamientoVisita = async (payload: any) => {
  const { data } = await api.post("relevamiento-visitas/", payload);
  if (data?.error) throw new Error(data.error);
  return data;
};

export const listarRelevamientosVisitas = async (
  filtros: RelevamientoListadoFiltros = {}
): Promise<RelevamientoListadoResponse> => {
  const params = new URLSearchParams();
  if (filtros.ps_codigo) params.set("ps_codigo", filtros.ps_codigo);
  if (filtros.fecha_desde) params.set("fecha_desde", filtros.fecha_desde);
  if (filtros.fecha_hasta) params.set("fecha_hasta", filtros.fecha_hasta);
  if (filtros.ejecutivo) params.set("ejecutivo", filtros.ejecutivo);
  if (filtros.limit !== undefined) params.set("limit", String(filtros.limit));
  if (filtros.offset !== undefined) params.set("offset", String(filtros.offset));

  const suffix = params.toString() ? `?${params.toString()}` : "";
  const { data } = await api.get(`relevamiento-visitas/listar${suffix}`);
  if (data?.error) throw new Error(data.error);
  return {
    datos: data?.datos || [],
    total: Number(data?.total || 0),
    limit: Number(data?.limit || filtros.limit || 20),
    offset: Number(data?.offset || filtros.offset || 0),
    puede_ver_todas: Boolean(data?.puede_ver_todas),
  };
};

export const obtenerRelevamientoVisita = async (
  id: number
): Promise<RelevamientoDetalle | null> => {
  const { data } = await api.get(`relevamiento-visitas/${id}`);
  if (data?.error) throw new Error(data.error);
  return data?.datos || null;
};
